import { useState } from 'react';
import { ventasRepository } from '@almacenes/core';
import { readPrintConfig, printTicketHtml } from './usePrintConfig';
import { buildTicketHtml, fetchPdf417 } from '../utils/ticket-html';

export const usePrintBoleta = () => {
  const [loadingPrintId, setLoadingPrintId] = useState<number | null>(null);

  const printBoleta = async (boletaId: number) => {
    console.warn('[PrintBoleta] Iniciando impresión. boletaId:', boletaId);
    console.warn('[PrintBoleta] electronAPI:', typeof (window as any).electronAPI);
    console.warn('[PrintBoleta] printContent:', typeof (window as any).electronAPI?.printContent);
    setLoadingPrintId(boletaId);
    try {
      const boleta = await ventasRepository.obtenerBoletaParaImprimir(boletaId);
      const imagenPDF417 = await fetchPdf417(boleta);
      const printConfig = readPrintConfig();
      const contenido = buildTicketHtml(boleta, imagenPDF417, printConfig);
      console.warn('[PrintBoleta] printConfig:', printConfig);
      await printTicketHtml(contenido, printConfig);
    } catch (error) {
      console.error('Error al imprimir boleta:', error);
    } finally {
      setLoadingPrintId(null);
    }
  };

  return {
    printBoleta,
    loadingPrintId,
  };
};
